import angular from 'angular'
import modalUploadListCtrl from './modalUploadListCtrl'
import modalInvoiceDetailCtrl from './modalInvoiceDetailCtrl'
import modalListCtrl from './modalListCtrl'
import modalInvoiceInfo from './modalInvoiceInfo'

import { reimbursement } from 'redevConfig'
const list = (reimbursement && reimbursement.list) || ''
const add = (reimbursement && reimbursement.add) || ''
const detail = (reimbursement && reimbursement.detail) || ''

const reimburseListPage = list ? require(`redevelopment/input/reimbursement/${list.templateName}`) : require('./view/reimburseList.html')
const reimburseListCtrl = list ? require(`redevelopment/input/reimbursement/${list.controllerName}`) : require('./reimburseListCtrl')
const reimburseEditPage = add ? require(`redevelopment/input/reimbursement/${add.templateName}`) : require('./view/reimburseEdit.html')
const reimburseEditCtrl = add ? require(`redevelopment/input/reimbursement/${add.controllerName}`) : require('./reimburseEditCtrl')
const reimburseDetailPage = detail ? require(`redevelopment/input/reimbursement/${detail.templateName}`) : require('./view/reimburseDetail.html')
const reimburseDetailCtrl = detail ? require(`redevelopment/input/reimbursement/${detail.controllerName}`) : require('./reimburseDetailCtrl')
export default angular
    .module('input.reimburseManage.reimbursement', []).config(['$stateProvider', function config($stateProvider) {
        $stateProvider
            .state('input.reimburseManage.reimbursement', {
                url: '/reimbursement',
                abstract: true,
                template: '<div ui-view></div>',
                default: 'input.reimburseManage.reimbursement.list',
                title: '报销单据',
            })
            .state('input.reimburseManage.reimbursement.list', {
                url: '/list',
                template: reimburseListPage,
                controller: 'reimburseListCtrl',
            })
            .state('input.reimburseManage.reimbursement.add', {
                url: '/add',
                template: reimburseEditPage,
                controller: 'reimburseEditCtrl',
                title: '创建报销',
            })
            .state('input.reimburseManage.reimbursement.edit', {
                url: '/edit/:expenseId',
                template: reimburseEditPage,
                controller: 'reimburseEditCtrl',
                title: '编辑报销',
            })
            .state('input.reimburseManage.reimbursement.detail', {
                url: '/detail/:expenseId',
                template: reimburseDetailPage,
                controller: 'reimburseDetailCtrl',
                title: '报销详情',
            })
    }])
    .controller('reimburseListCtrl', reimburseListCtrl.default)
    .controller('reimburseEditCtrl', reimburseEditCtrl.default)
    .controller('reimburseDetailCtrl', reimburseDetailCtrl.default)
    .controller('modalUploadListCtrl', modalUploadListCtrl)
    .controller('modalInvoiceDetailCtrl', modalInvoiceDetailCtrl)
    .controller('modalListCtrl', modalListCtrl)
    .controller('modalInvoiceInfo', modalInvoiceInfo)
    .name



// WEBPACK FOOTER //
// ./src/app/input/reimburseManage/reimbursement/index.js